<template>
    <div class="d-flex w-100 justify-content-end" @click="handleClick">

        <div :class="['d-flex w-100 align-items-center justify-content-end', dailyReport ? 'gap-2' : 'gap-1']">
            <!-- ABSENT -->
            <basic-button
                :loading="loading['missing']"
                :disabled="loading['disabled']"
                v-if="validateStatus([CHILD_STATUS.PENDING])"
                :class="['btn-secondary tour-checkin', dailyReport ? 'btn btn-fluid py-3' : 'btn-ssm']"
                data-bs-toggle="dropdown" aria-expanded="false"
                :text="trans('general.module.attendance.missing')"/>
            <ul v-if="validateStatus([CHILD_STATUS.PENDING])" class="dropdown-menu dropdown-menu-end">
                <li><h6 class="dropdown-header">{{ trans('general.module.report.missing_reasons') }}:</h6></li>
                <li v-on:click="changeStatus('missing', trans('general.module.report.status_alert.missing.vacation'))"
                    class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.missing.vacation') }}
                </li>
                <li v-on:click="changeStatus('missing', trans('general.module.report.status_alert.missing.sick'))"
                    class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.missing.sick') }}
                </li>
                <li v-on:click="changeStatus('missing', trans('general.module.report.status_alert.missing.doctor_appointment'))"
                    class="hov-pointer dropdown-item">
                    {{ trans('general.module.report.status_alert.missing.doctor_appointment') }}
                </li>
                <li v-on:click="changeStatus('missing', trans('general.module.report.status_alert.missing.home_day'))"
                    class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.missing.home_day') }}
                </li>
                <li v-on:click="changeStatus('missing', trans('general.module.report.status_alert.missing.no_show'))"
                    class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.missing.no_show') }}
                </li>
                <li class=" align-content-center px-3">
                    <div class="input-group my-2  ">
                        <input type="text" v-model="customMissing" class="form-control"
                               :placeholder="trans('general.module.report.status_alert.missing.custom_message')"
                               aria-label="Custom message" aria-describedby="button-custom">
                        <button class="btn btn-delete btn-secondary "
                                :disabled="customMissing === ''"
                                v-on:click="changeStatus(CHILD_STATUS.MISSING, customMissing)" type="button"
                                id="button-custom">
                            <i class="fi fi-rr-arrow-small-right"></i>
                        </button>
                    </div>
                </li>
            </ul>

            <!-- CHECK IN -->
            <basic-button
                :loading="loading['check_in']"
                :disabled="loading['disabled']"
                v-if="validateStatus([CHILD_STATUS.PENDING, CHILD_STATUS.MISSING])"
                :class="['btn-secondary tour-checkin btn-success', dailyReport ? 'btn btn-fluid py-3' : 'btn-ssm']"
                :text="trans('general.module.attendance.check_in')"
                v-on:click="changeStatus(CHILD_STATUS.CHECKIN)"/>
        </div>

        <!-- CHECK OUT -->
        <basic-button
            :loading="loading['check_out']"
            :disabled="loading['disabled']"
            v-if="validateStatus([CHILD_STATUS.CHECKIN])"
            data-bs-toggle="dropdown" aria-expanded="false"
            :class="['btn-ssm btn-secondary btn-danger', {'d-none d-md-flex': !showAll}]"
            :text="trans('general.module.attendance.check_out')"/>
        <ul v-if="validateStatus([CHILD_STATUS.CHECKIN])" class="dropdown-menu dropdown-menu-end">
            <li><h6 class="dropdown-header">{{ trans('general.module.report.checkout_by') }}:</h6></li>
            <li v-on:click="changeStatus(CHILD_STATUS.CHECKOUT, trans('general.module.report.status_alert.checkout.transport'))"
                class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.checkout.transport') }}
            </li>
            <li v-on:click="changeStatus(CHILD_STATUS.CHECKOUT, trans('general.module.report.status_alert.checkout.parent'))"
                class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.checkout.parent') }}
            </li>
            <li v-on:click="changeStatus(CHILD_STATUS.CHECKOUT, trans('general.module.report.status_alert.checkout.babysitter'))"
                class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.checkout.babysitter') }}
            </li>
            <li v-on:click="changeStatus(CHILD_STATUS.CHECKOUT, trans('general.module.report.status_alert.checkout.grandparent'))"
                class="hov-pointer dropdown-item">{{ trans('general.module.report.status_alert.checkout.grandparent') }}
            </li>
            <li class=" align-content-center px-3">
                <div class="input-group my-2  ">
                    <input type="text" v-model="customReason" class="form-control"
                           :placeholder="trans('general.module.report.status_alert.checkout.custom_reason')"
                           aria-label="Custom reason" aria-describedby="button-custom">
                    <button class="btn btn-delete btn-secondary "
                            :disabled="customReason === ''"
                            v-on:click="changeStatus(CHILD_STATUS.CHECKOUT, customReason)" type="button"
                            id="button-custom">
                        <i class="fi fi-rr-arrow-small-right"></i>
                    </button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {CHILD_STATUS} from "../../services/Defaults";
import BasicButton from "./BasicButton.vue";

export default {
    name: "AttendanceAction",

    props: {
        status: String,
        child: {
            type: Object,
            default: () => {
                return {}
            }
        },
        childId: String | Number,
        showAll: {
            type: Boolean,
            default: true
        },
        getStatusIcon: {
            type: Function,
            default: () => {
                return () => {
                    return ''
                }
            }
        },
        dailyReport: {
            type: Boolean,
            default: false
        }
    },
    components: {
        BasicButton
    },
    data() {
        return {
            customMissing: "",
            customReason: "",
            CHILD_STATUS: CHILD_STATUS,
            loading: {
                check_in: false,
                check_out: false,
                missing: false,
                disabled: false
            },
        }
    },
    methods: {
        validateStatus: function (statuses) {
            return statuses.includes(this.status)
        },

        changeStatus: function (type, description) {
            this.loading['disabled'] = true;
            this.loading[type] = true;
            axios.post(`/child-report/${this.childId}/appearance`, {
                type,
                description
            }).then((response) => {
                let data = response.data.data;
                this.$emit('status-changed', data)
            }).catch(error => {
                this.$notify({type: 'error', text: error.response.data.message});
            }).finally(() => {
                this.loading['disabled'] = false;
                this.loading[type] = false;
            });
        },

        handleClick() {
            this.$emit('click')
        }
    }
}
</script>

<style scoped>
.status-icon {
    font-size: 24px;
}
</style>
